export * from './modules/calendar.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/angular-calendar/index.js
// module id = ../../../../angular-calendar/index.js
// module chunks = common